<form [formGroup]="formGroup" class="bg-white">
  <div class="development-title !pl-[36px] sticky top-0 !z-50">
    Pre-Qualification Questionnaire (PQQ)
    <span class="comapny-general-info"> Relevant Construction Experience </span>
  </div>

  <div class="container p-5 !pt-0 !pb-0">
    <div #container_wrapper id="container_wrapper" class="container_wrapper">
      <div
        class="container-fluid flex justify-center h-auto !pt-0 !m-[3px] !mt-[5px] !mb-[0px] !pb-[0px]"
      >
        <div class="!pb-0 !bg-[#ffffff] w-full !pt-[0px]">
          <h4 class="subTitle !mt-[17px] !pl-[16px] !mb-[0px] !pt-0 !pb-0">
            Relevant Construction Experience
          </h4>
          <h4 class="input-label !pl-[16px] !mb-[0px] !pt-[24px] !pb-0">
            Provide details of up to three construction projects that are
            similar in scope and size to this procurement. Include the
            following:
          </h4>

          <h4 class="input-label !pl-[16px] !mb-[0px] !pt-[25px]">Project 1</h4>
          <div class="!mb-[10px]">
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container p-5 !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Project Name </mat-label>
                    <input
                      matInput
                      formControlName="cons_project_1_name"
                      placeholder="Project Name"
                    />
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup.get('cons_project_1_name').hasError('required') &&
                    formGroup.get('cons_project_1_name').touched
                  "
                >
                  Project Name is Required
                </mat-error>
              </div>
              <div class="container p-5 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Client Name </mat-label>
                    <input
                      matInput
                      formControlName="cons_project_1_client"
                      placeholder="Client Name"
                    />
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_1_client')
                      .hasError('required') &&
                    formGroup.get('cons_project_1_client').touched
                  "
                >
                  Client Name is Required
                </mat-error>
              </div>
              <div class="container p-5 !pb-0 !pt-0">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label>Start Date</mat-label>
                    <input
                      [matDatepicker]="start_date1"
                      matInput
                      formControlName="cons_project_1_start_date"
                      placeholder="Start Date"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="start_date1"
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                      #start_date1
                      startView="year"
                    ></mat-datepicker>
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_1_start_date')
                      .hasError('required') &&
                    formGroup.get('cons_project_1_start_date').touched
                  "
                >
                  Project Start Date is Required
                </mat-error>
              </div>
              <div class="container p-5 !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> End Date </mat-label>
                    <input
                      matInput
                      [matDatepicker]="end_date1"
                      formControlName="cons_project_1_end_date"
                      placeholder="End Date"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="end_date1"
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                      #end_date1
                      startView="year"
                    ></mat-datepicker>
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_1_end_date')
                      .hasError('required') &&
                    formGroup.get('cons_project_1_end_date').touched
                  "
                >
                  Project End Date is Required
                </mat-error>
              </div>
              <div class="container px-5 !py-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label>Project Value</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="cons_project_1_value"
                      placeholder="Project Value"
                      currencyMask
                      [options]="{
                      prefix: currencySymbol,
                      thousands: ',',
                      decimal: '',
                      nullable: true,
                      allowZero: false,
                      precision: 0,
                      max: 100000000000,
                    }"
                    />
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_1_value')
                      .hasError('required') &&
                    formGroup.get('cons_project_1_value').touched
                  "
                >
                  Project Value is Required
                </mat-error>
                <div class="justify-items-center !w-[500px]">
                  <span class="w-full text-[12px]">
                    {{
                      numberToWords(
                        formGroup.get("cons_project_1_value")?.value
                      ) | titlecase
                    }}
                  </span>
                </div>
              </div>
              <div class="container p-5 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label>
                      Your Role (Main Contractor/Subcontractor)
                    </mat-label>
                    <input
                      matInput
                      formControlName="cons_project_1_role"
                      placeholder="Your Role (Main Contractor/Subcontractor)"
                    />
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup.get('cons_project_1_role').hasError('required') &&
                    formGroup.get('cons_project_1_role').touched
                  "
                >
                  Your Role in project is Required
                </mat-error>
              </div>
              <div class="container p-5 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px] !h-[150px]"
                    appearance="outline"
                  >
                    <mat-label> Description of Work </mat-label>
                    <textarea
                      matInput
                      formControlName="cons_project_1_des"
                      placeholder="Description of Work"
                    ></textarea>
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup.get('cons_project_1_des').hasError('required') &&
                    formGroup.get('cons_project_1_des').touched
                  "
                >
                  Project Description is Required
                </mat-error>
              </div>
              <div class="container p-5 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px] !h-[150px]"
                    appearance="outline"
                  >
                    <mat-label>
                      Any Challenges Faced and How They Were Overcome
                    </mat-label>
                    <textarea
                      matInput
                      formControlName="cons_project_1_challenges"
                      placeholder="Any Challenges Faced and How They Were Overcome"
                    ></textarea>
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_1_challenges')
                      .hasError('required') &&
                    formGroup.get('cons_project_1_challenges').touched
                  "
                >
                  Challenges in Project are Required
                </mat-error>
              </div>
            </div>

            <div
              class="container row-span-1 p-5 !pr-[9.5rem] !pt-0 !pb-0 !mb-[15px]"
            >
              <mat-form-field class="!w-[100%]" appearance="outline">
                <mat-label>Key Achievements</mat-label>
                <textarea
                  formControlName="cons_project_1_Key_Achievements"
                  rows="3"
                  type="text"
                  matInput
                  placeholder="Key Achievements"
                ></textarea>
              </mat-form-field>
              <mat-error
                class="!mt-[6px]"
                *ngIf="
                  formGroup
                    .get('cons_project_1_Key_Achievements')
                    .hasError('required') &&
                  formGroup.get('cons_project_1_Key_Achievements').touched
                "
              >
                Key Achievements is Required
              </mat-error>
            </div>
            <div class="col-span-full !pr-[8.2rem]">
              <app-file-manager
                [IsDragNDrop]="true"
                [newFileControlName]="'consProject1FileControl'"
                (newFilesUpdatedEvent)="handleNewFiles($event)"
                [oldFiles]="oldConsProject1Files"
                (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
              ></app-file-manager>
            </div>
          </div>

          <h4 class="input-label !pl-[16px] !mb-[0px] !pt-[15px]">Project 2</h4>
          <div class="!mb-[10px]">
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container p-5 !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Project Name </mat-label>
                    <input
                      matInput
                      formControlName="cons_project_2_name"
                      placeholder="Project Name"
                    />
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup.get('cons_project_2_name').hasError('required') &&
                    formGroup.get('cons_project_2_name').touched
                  "
                >
                  Project Name is Required
                </mat-error>
              </div>
              <div class="container p-5 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Client Name </mat-label>
                    <input
                      matInput
                      formControlName="cons_project_2_client"
                      placeholder="Client Name"
                    />
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_2_client')
                      .hasError('required') &&
                    formGroup.get('cons_project_2_client').touched
                  "
                >
                  Client Name is Required
                </mat-error>
              </div>
              <div class="container p-5 !pb-0 !pt-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label>Start Date</mat-label>
                    <input
                      [matDatepicker]="start_date2"
                      matInput
                      formControlName="cons_project_2_start_date"
                      placeholder="Start Date"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="start_date2"
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                      #start_date2
                      startView="year"
                    ></mat-datepicker>
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_2_start_date')
                      .hasError('required') &&
                    formGroup.get('cons_project_2_start_date').touched
                  "
                >
                  Project Start Date is Required
                </mat-error>
              </div>
              <div class="container p-5 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> End Date </mat-label>
                    <input
                      matInput
                      [matDatepicker]="end_date2"
                      formControlName="cons_project_2_end_date"
                      placeholder="End Date"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="end_date2"
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                      #end_date2
                      startView="year"
                    ></mat-datepicker>
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_2_end_date')
                      .hasError('required') &&
                    formGroup.get('cons_project_2_end_date').touched
                  "
                >
                  Project End Date is Required
                </mat-error>
              </div>
              <div class="container px-5 !py-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label>Project Value</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="cons_project_2_value"
                      placeholder="Project Value"
                      currencyMask
                      [options]="{
                      prefix: currencySymbol,
                      thousands: ',',
                      decimal: '',
                      nullable: true,
                      allowZero: false,
                      precision: 0,
                      max: 100000000000,
                      }"
                    />
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_2_value')
                      .hasError('required') &&
                    formGroup.get('cons_project_2_value').touched
                  "
                >
                  Project Value is Required
                </mat-error>
                <div class="justify-items-center !w-[500px]">
                  <span class="w-full text-[12px]">
                    {{
                      numberToWords(
                        formGroup.get("cons_project_2_value")?.value
                      ) | titlecase
                    }}
                  </span>
                </div>
              </div>
              <div class="container p-5 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label>
                      Your Role (Main Contractor/Subcontractor)
                    </mat-label>
                    <input
                      matInput
                      formControlName="cons_project_2_role"
                      placeholder="Your Role (Main Contractor/Subcontractor)"
                    />
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup.get('cons_project_2_role').hasError('required') &&
                    formGroup.get('cons_project_2_role').touched
                  "
                >
                  Your Role in project is Required
                </mat-error>
              </div>
              <div class="container p-5 !pt-0 !pb-0 ">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px] !h-[150px]"
                    appearance="outline"
                  >
                    <mat-label> Description of Work </mat-label>
                    <textarea
                      matInput
                      formControlName="cons_project_2_des"
                      placeholder="Description of Work"
                    ></textarea>
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup.get('cons_project_2_des').hasError('required') &&
                    formGroup.get('cons_project_2_des').touched
                  "
                >
                  Project Description is Required
                </mat-error>
              </div>
              <div class="container p-5 !pt-0 !pb-0 ">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px] !h-[150px]"
                    appearance="outline"
                  >
                    <mat-label>
                      Any Challenges Faced and How They Were Overcome
                    </mat-label>
                    <textarea
                      matInput
                      formControlName="cons_project_2_challenges"
                      placeholder="Any Challenges Faced and How They Were Overcome"
                    ></textarea>
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_2_challenges')
                      .hasError('required') &&
                    formGroup.get('cons_project_2_challenges').touched
                  "
                >
                  Challenges in Project are Required
                </mat-error>
              </div>
            </div>
            <div class="container px-5 !py-0 !pr-[9.5rem] !mb-[10px]">
              <mat-form-field class="!w-[100%]" appearance="outline">
                <mat-label>Key Achievements</mat-label>
                <textarea
                  formControlName="cons_project_2_Key_Achievements"
                  rows="3"
                  type="text"
                  matInput
                  placeholder="Key Achievements"
                ></textarea>
              </mat-form-field>
              <mat-error
                class="!mt-[6px]"
                *ngIf="
                  formGroup
                    .get('cons_project_2_Key_Achievements')
                    .hasError('required') &&
                  formGroup.get('cons_project_2_Key_Achievements').touched
                "
              >
                Key Achievements is required
              </mat-error>
            </div>
            <div class="col-span-full !pr-[8.2rem]">
              <app-file-manager
                [IsDragNDrop]="true"
                [newFileControlName]="'consProject2FileControl'"
                (newFilesUpdatedEvent)="handleNewFiles($event)"
                [oldFiles]="oldConsProject2Files"
                (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
              ></app-file-manager>
            </div>
          </div>
          <h4 class="input-label !pl-[16px] !mb-[0px] !pt-[15px]">Project 3</h4>
          <div>
            <div
              class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container p-5 !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Project Name </mat-label>
                    <input
                      matInput
                      formControlName="cons_project_3_name"
                      placeholder="Project Name"
                    />
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup.get('cons_project_3_name').hasError('required') &&
                    formGroup.get('cons_project_3_name').touched
                  "
                >
                  Project Name is Required
                </mat-error>
              </div>
              <div class="container p-5 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Client Name </mat-label>
                    <input
                      matInput
                      formControlName="cons_project_3_client"
                      placeholder="Client Name"
                    />
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_3_client')
                      .hasError('required') &&
                    formGroup.get('cons_project_3_client').touched
                  "
                >
                  Client Name is Required
                </mat-error>
              </div>
              <div class="container p-5 !pb-0 !pt-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label>Start Date</mat-label>
                    <input
                      [matDatepicker]="start_date3"
                      matInput
                      formControlName="cons_project_3_start_date"
                      placeholder="Start Date"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="start_date3"
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                      #start_date3
                      startView="year"
                    ></mat-datepicker>
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_3_start_date')
                      .hasError('required') &&
                    formGroup.get('cons_project_3_start_date').touched
                  "
                >
                  Project Start Date is Required
                </mat-error>
              </div>
              <div class="container p-5 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> End Date </mat-label>
                    <input
                      matInput
                      [matDatepicker]="end_date3"
                      formControlName="cons_project_3_end_date"
                      placeholder="End Date"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="end_date3"
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                      #end_date3
                      startView="year"
                    ></mat-datepicker>
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_3_end_date')
                      .hasError('required') &&
                    formGroup.get('cons_project_3_end_date').touched
                  "
                >
                  Project End Date is Required
                </mat-error>
              </div>
              <div class="container px-5 !py-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label>Project Value</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="cons_project_3_value"
                      placeholder="Project Value"
                      currencyMask
                      [options]="{
                      prefix: currencySymbol,
                      thousands: ',',
                      decimal: '',
                      nullable: true,
                      allowZero: false,
                      precision: 0,
                      max: 100000000000,
                      }"
                    />
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_3_value')
                      .hasError('required') &&
                    formGroup.get('cons_project_3_value').touched
                  "
                >
                  Project Value is Required
                </mat-error>
                <div class="justify-items-center !w-[500px]">
                  <span class="w-full text-[12px]">
                    {{
                      numberToWords(
                        formGroup.get("cons_project_3_value")?.value
                      ) | titlecase
                    }}
                  </span>
                </div>
              </div>
              <div class="container p-5 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label>
                      Your Role (Main Contractor/Subcontractor)
                    </mat-label>
                    <input
                      matInput
                      formControlName="cons_project_3_role"
                      placeholder="Your Role (Main Contractor/Subcontractor)"
                    />
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup.get('cons_project_3_role').hasError('required') &&
                    formGroup.get('cons_project_3_role').touched
                  "
                >
                  Your Role in project is Required
                </mat-error>
              </div>
              <div class="container p-5 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px] !h-[150px]"
                    appearance="outline"
                  >
                    <mat-label> Description of Work </mat-label>
                    <textarea
                      matInput
                      formControlName="cons_project_3_des"
                      placeholder="Description of Work"
                    ></textarea>
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup.get('cons_project_3_des').hasError('required') &&
                    formGroup.get('cons_project_3_des').touched
                  "
                >
                  Project Description is Required
                </mat-error>
              </div>
              <div class="container p-5 !pt-0 !pb-0 !mb-[10px]">
                <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                  <mat-form-field
                    class="!w-full !mb-[0px] !h-[150px]"
                    appearance="outline"
                  >
                    <mat-label>
                      Any Challenges Faced and How They Were Overcome
                    </mat-label>
                    <textarea
                      matInput
                      formControlName="cons_project_3_challenges"
                      placeholder="Any Challenges Faced and How They Were Overcome"
                    ></textarea>
                  </mat-form-field>
                </div>
                <mat-error
                  class="!mt-[6px]"
                  *ngIf="
                    formGroup
                      .get('cons_project_3_challenges')
                      .hasError('required') &&
                    formGroup.get('cons_project_3_challenges').touched
                  "
                >
                  Challenges in Project are Required
                </mat-error>
              </div>
            </div>
            <div class="container p-5 !pt-0 !pr-[9.5rem] !pb-0 !mb-[10px]">
              <mat-form-field class="!w-[100%]" appearance="outline">
                <mat-label>Key Achievements</mat-label>
                <textarea
                  formControlName="cons_project_3_Key_Achievements"
                  rows="3"
                  type="text"
                  matInput
                  placeholder="Key Achievements"
                ></textarea>
              </mat-form-field>
              <mat-error
                class="!mt-[6px]"
                *ngIf="
                  formGroup
                    .get('cons_project_3_Key_Achievements')
                    .hasError('required') &&
                  formGroup.get('cons_project_3_Key_Achievements').touched
                "
              >
                Key Achievements is Required
              </mat-error>
            </div>
            <div class="col-span-full !pr-[8.2rem]">
              <app-file-manager
                [IsDragNDrop]="true"
                [newFileControlName]="'consProject3FileControl'"
                (newFilesUpdatedEvent)="handleNewFiles($event)"
                [oldFiles]="oldConsProject3Files"
                (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
              ></app-file-manager>
            </div>
          </div>

          <h4 class="input-label !pl-[16px] !pb-0 !mb-[0px] !pt-[21px]">
            Key Personnel
          </h4>
          <h4
            class="key-personal-value !pl-[16px] !mb-[0px] !pt-[12px] !pb-[15px]"
          >
            List the key personnel proposed for this project, including:
          </h4>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
          >
            <div class="container p-5 !pt-0 !pb-0">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field class="!w-full !mb-[0px]" appearance="outline">
                  <mat-label> Name </mat-label>
                  <input
                    matInput
                    formControlName="key_personnel_name"
                    placeholder="Name"
                  />
                </mat-form-field>
              </div>
              <mat-error
                class="!mt-[6px]"
                *ngIf="
                  formGroup.get('key_personnel_name').hasError('required') &&
                  formGroup.get('key_personnel_name').touched
                "
              >
                Name is required
              </mat-error>
            </div>
            <div class="container p-5 !pt-0 !pb-0 !mb-[10px]">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field class="!w-full !mb-[0px]" appearance="outline">
                  <mat-label> Role on the Project </mat-label>
                  <input
                    matInput
                    formControlName="key_personnel_role"
                    placeholder=" Role on the Project"
                  />
                </mat-form-field>
              </div>
              <mat-error
                class="!mt-[6px]"
                *ngIf="
                  formGroup.get('key_personnel_role').hasError('required') &&
                  formGroup.get('key_personnel_role').touched
                "
              >
                Role is required
              </mat-error>
            </div>

            <div class="container p-5 !pb-0 !pt-0 !mb-[10px]">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field class="!w-full !mb-[0px]" appearance="outline">
                  <mat-label>Qualifications</mat-label>
                  <input
                    matInput
                    formControlName="key_personnel_quals"
                    placeholder="Qualifications"
                  />
                </mat-form-field>
              </div>
              <mat-error
                class="!mt-[6px]"
                *ngIf="
                  formGroup.get('key_personnel_quals').hasError('required') &&
                  formGroup.get('key_personnel_quals').touched
                "
              >
                Qualification is required
              </mat-error>
            </div>

            <div class="container p-5 !pb-0 !pt-0 !mb-[10px]">
              <div class="rounded !pb-0 !pt-0 !max-w-[500px]">
                <mat-form-field class="!w-full !mb-[0px]" appearance="outline">
                  <mat-label>Experience years in relevant projects:</mat-label>
                  <input
                    type="number"
                    matInput
                    formControlName="key_personnel_exp"
                    placeholder="Experience (years and relevant projects): "
                  />
                </mat-form-field>
              </div>
              <mat-error
                class="!mt-[6px]"
                *ngIf="
                  formGroup.get('key_personnel_exp').hasError('required') &&
                  formGroup.get('key_personnel_exp').touched
                "
              >
                Experience is required
              </mat-error>
            </div>
          </div>

          <h3
            class="supply-chain-subcontractor !pl-[16px] !mb-[0px] !pt-[12px] !pb-[22px]"
          >
            Subcontractors and Supply Chain
          </h3>
          <div
            class="grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <div
              class="!mt-[6px] !mb-[19px] container p-5 !pt-0 !pr-[9.5rem] !pb-0"
            >
              <div class="rounded !pb-0 !pt-0">
                <div
                  class="long-section !pl-10 !pb-0 !pt-0 flex items-center !w-full !h-[114px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
                >
                  <label>
                    Do you intend to use subcontractors for this project?
                    <br />If yes, provide details of key subcontractors and
                    their scope of work.
                  </label>
                  <mat-radio-group
                    formControlName="use_subcons"
                    aria-label="Health and Safety Policy"
                    class="flex gap-4"
                  >
                    <mat-radio-button value="1">Yes</mat-radio-button>
                    <mat-radio-button value="0">No</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div
              class="container p-5 !pt-0 !pb-0 !mt-[29px] !pr-[9.5rem]"
              *ngIf="formGroup.get('use_subcons').value === '1'"
            >
              <div class="rounded !pb-0 !pt-0">
                <mat-form-field
                  class="!w-full !h-[127px] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Provide Detail </mat-label>
                  <textarea
                    matInput
                    formControlName="subcons_details"
                    placeholder="Provide Detail"
                    rows="3"
                  ></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="container p-5 !pt-0 !pr-[9.5rem] !pb-0">
              <div class="rounded !pb-0 !pt-0">
                <mat-form-field
                  class="!w-full !mb-[0px] !h-[223px]"
                  appearance="outline"
                >
                  <mat-label>
                    Describe how you manage your supply chain and ensure
                    subcontractor compliance with project standards. 
                  </mat-label>
                  <textarea
                    matInput
                    formControlName="subcon_compliance_details"
                    rows="6"
                    placeholder="Describe how you manage your supply chain and ensure subcontractor compliance with project standards. "
                  ></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
